export const CINCREMENET = "cart/increment";
export const CDECREMENT = "cart/decrement";
